import React, { Component } from "react";
import { DatePicker, Select, Tooltip, Button, Spin } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import ChartJobRemain from "../../../ui/chart/job_remain";

import Cookies from "js-cookie";
import Api from "../../../services/ServiceApi";
import moment from "moment";
// import "./dashboard.css"

//  ===============  New DashBorad ====================

import ChartStatic from "../../../ui/chart_static/chart_static";

// import ChartPM from "../../../ui/chart/chart_pm";
import ChartAQM from "../../../ui/chart/chart_aqm";
import ChartQC from "../../../ui/chart/chart_qc";

import { Link } from "react-router-dom";

const { Option } = Select;
const { RangePicker } = DatePicker;

class Dashboard extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      data_dashbord: null,
      columns_equipment: [
        {
          title: "Material ID",
          dataIndex: "material_id",
          key: "material_id",
        },
        {
          title: "Material Name",
          dataIndex: "material_name",
          key: "material_name",
        },
        {
          title: "Name",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "Unit Code",
          dataIndex: "unit_code",
          key: "unit_code",
        },
      ],
      data_team_ranking: [],
      data_sla_claim: [
        {
          name: "PBTV",
          progess_sla: "100",
          total_job_left: "5",
          total_job_right: "5",
        },
        {
          name: "Nationwide",
          progess_sla: "100",
          total_job_left: "5",
          total_job_right: "5",
        },
        {
          name: "Bangkok Jam1&2",
          progess_sla: "95",
          total_job_left: "5",
          total_job_right: "5",
        },
        {
          name: "In Mall",
          progess_sla: "90",
          total_job_left: "5",
          total_job_right: "5",
        },
        {
          name: "Digital MRT",
          progess_sla: "85",
          total_job_left: "5",
          total_job_right: "5",
        },
        {
          name: "BigC",
          progess_sla: "80",
          total_job_left: "5",
          total_job_right: "5",
        },
        {
          name: "Singnature",
          progess_sla: "75",
          total_job_left: "5",
          total_job_right: "5",
        },
      ],
      data_sla_photo: [
        {
          name: "QC",
          progess_sla: "95",
          total_job_left: "5",
          total_job_right: "5",
        },
        {
          name: "Photo",
          progess_sla: "90",
          total_job_left: "5",
          total_job_right: "5",
        },
      ],
      data_sla_report: [
        {
          name: "Report",
          progess_sla: "100",
          total_job_left: "5",
          total_job_right: "5",
        },
      ],
      data_top_asset: [],
      data_customer_service: [
        {
          name: "Claim",
          data: [
            26, 38, 67, 87, 89, 132, 142, 179, 190, 221, 260, 353, 485, 498,
            524, 557, 558, 579, 612, 628, 640, 647, 659, 733, 743, 834, 839,
            874, 876, 997,
          ],
        },
        {
          name: "Clean",
          data: [
            114, 119, 176, 200, 206, 221, 222, 233, 289, 302, 345, 386, 386,
            395, 404, 405, 453, 454, 487, 553, 635, 657, 719, 767, 797, 826,
            833, 865, 915, 957,
          ],
        },
        {
          name: "Preventive Maintenance",
          data: [
            6, 22, 51, 66, 67, 152, 182, 186, 225, 326, 330, 356, 424, 438, 475,
            501, 543, 629, 633, 664, 685, 694, 703, 741, 791, 857, 896, 957,
            965, 990,
          ],
        },
        {
          name: "Post",
          data: [
            89, 108, 109, 148, 164, 196, 204, 264, 354, 356, 471, 478, 534, 558,
            581, 599, 607, 746, 761, 771, 782, 850, 857, 893, 924, 927, 933,
            944, 973, 990,
          ],
        },
      ],
      data_job_summary: [
        {
          name: "Photo",
          data: [
            26, 38, 67, 87, 89, 132, 142, 179, 190, 221, 260, 353, 485, 498,
            524, 557, 558, 579, 612, 628, 640, 647, 659, 733, 743, 834, 839,
            874, 876, 997,
          ],
        },
        {
          name: "Report",
          data: [
            114, 119, 176, 200, 206, 221, 222, 233, 289, 302, 345, 386, 386,
            395, 404, 405, 453, 454, 487, 553, 635, 657, 719, 767, 797, 826,
            833, 865, 915, 957,
          ],
        },
        {
          name: "Graphic Layout",
          data: [
            6, 22, 51, 66, 67, 152, 182, 186, 225, 326, 330, 356, 424, 438, 475,
            501, 543, 629, 633, 664, 685, 694, 703, 741, 791, 857, 896, 957,
            965, 990,
          ],
        },
        {
          name: "Run zone",
          data: [
            89, 108, 109, 148, 164, 196, 204, 264, 354, 356, 471, 478, 534, 558,
            581, 599, 607, 746, 761, 771, 782, 850, 857, 893, 924, 927, 933,
            944, 973, 990,
          ],
        },
      ],
      lodding: false,
      loading_refresh_data: false,
      masterMonth: [
        { value: 1, text: "January" },
        { value: 2, text: "February" },
        { value: 3, text: "March" },
        { value: 4, text: "April" },
        { value: 5, text: "May" },
        { value: 6, text: "June" },
        { value: 7, text: "July" },
        { value: 8, text: "August" },
        { value: 9, text: "September" },
        { value: 10, text: "October" },
        { value: 11, text: "November" },
        { value: 12, text: "December" },
      ],
      masterYear: [],
      valueMonth:  [],
      valueYear: [],
      valueDateTo : null
    };
  }

  async componentDidMount() {
    var setdate = [];
    var setYear = [];
    let now = new Date();
    let next30days = new Date(now.setDate(now.getDate() - 30));
    setdate.push(next30days.toUTCString());
    setdate.push(new Date());
    for (let i = 0; i < 3; i++) {
      setYear.push({
        value: now.getFullYear() - i,
        text: now.getFullYear() - i,
      });
    }
 
    this.filterDataProcess(setdate);
    this.setState({
      masterYear: setYear,
      lodding: false,
    });
  }

  filterDataProcess = async (date) => {
    this.setState({
      lodding: false,
    });
    const get_detail = await Api.post("planb_dashboard_static", {
      company_id: Cookies.get("companyid"),
      operator_id: 2,
      project_id: Cookies.get("project_id"),
      date_start: moment(date[0]).format("YYYY-MM-DD"),
      date_end: moment(date[1]).format("YYYY-MM-DD"),
    });
    if (
      get_detail.data.data.top10asset.length > 0 &&
      get_detail.data.data.top10asset.length > 10
    ) {
      for (let i = 0; i < 10; i++) {
        this.state.data_top_asset.push(get_detail.data.data.top10asset[i]);
      }
    } else {
      for (let i = 0; i < get_detail.data.data.top10asset.length; i++) {
        this.state.data_top_asset.push(get_detail.data.data.top10asset[i]);
      }
    }
    this.setState({
      data_dashbord: get_detail.data.data,
      lodding: true,
    });
  };

  filterData = async (date) => {
    this.setState({
      data_top_asset: [],
      loading_refresh_data: true,
      valueDateTo : date
    });
    if (date !== undefined) {
      this.filterDataProcess(date);
    } else {
      var setdate = [];
      let now = new Date();
      let next30days = new Date(now.setDate(now.getDate() - 30));
      setdate.push(next30days.toUTCString());
      setdate.push(new Date());
      this.filterDataProcess(setdate);
    }
    this.setState({
      loading_refresh_data: false,
    });
  };

  onFilterData = async () => {
    this.setState({
      lodding: false,
    });
    var setMounth = "";
    var setYear = "";
    this.state.valueYear.forEach(element => setYear += element + ",")
    this.state.valueMonth.forEach(element => setMounth += element + ",")
    let now = new Date();
    const get_detail = await Api.post("planb_dashboard_static_V2", {
      company_id: "1",
      operator_id: 1,
      project_id: "1",
      i_year:
        this.state.valueYear === "" ? now.getFullYear() + 1 : setYear.substring(0, setYear.length - 1),
      i_month:
        this.state.valueMonth === ""
          ? now.getMonth()
          : setMounth.substring(0, setMounth.length - 1),
    });

    if (
      get_detail.data.data.top10asset.length > 0 &&
      get_detail.data.data.top10asset.length > 10
    ) {
      for (let i = 0; i < 10; i++) {
        this.state.data_top_asset.push(get_detail.data.data.top10asset[i]);
      }
    } else {
      for (let i = 0; i < get_detail.data.data.top10asset.length; i++) {
        this.state.data_top_asset.push(get_detail.data.data.top10asset[i]);
      }
    }
    this.setState({
      data_dashbord: get_detail.data.data,
      lodding: true,
    });
  };
  render() {
    return (
      <>
      <Spin spinning={!this.state.lodding} size="large" style={{marginTop: "20%"}}>
        {this.state.lodding === true ? (
          <>
              <div
                style={this.props.status === 0 ? null : { marginTop: "-4rem" }}
              >
                <div
                  className="wrapper-header d-flex"
                  style={{ height: "284px" }}
                >
                  <div className="container-fluid">
                    <div className="row align-items-center mt-3">
                      <div
                        className="ant-col ant-col-xs-24 ant-col-xl-24"
                        style={{ textAlign: "left", marginLeft: "20px" }}
                      >
                        <img
                          src={Api.absoluteUrl("/icon/dashboard_white.svg")}
                          className="mr-3"
                          alt=""
                        />
                        <h2 className="c-white text-uppercase m-0 d-inline-block font-mont-b fs-20">
                          Static Dashboard
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="wrapper-body" style={{ marginTop: "-210px" }}>
                  <div className="container-fluid">
                    <div className="card-dashboard mb-4">
                      <div className="row ">
                        <div className="col-sm-auto col-md-2">
                          <Select
                            placeholder="Please select"
                            optionFilterProp="children"
                            className="font-mont-r fs-12"
                            value=""
                            style={{ width: "100%" }}
                          >
                            <Option value="">Date</Option>
                          </Select>
                        </div>
                        <div className="col-sm-auto col-md-3">
                          <RangePicker
                            onChange={(e) => this.filterData(e)}
                            style={{ color: "#000f9f ", width: "100%" }}
                            value={this.state.valueDateTo}
                          />
                        </div>
                        <div className="col-sm-auto col-md-3">
                          <Select
                            mode="multiple"
                            style={{
                              width: "100%",
                            }}
                            placeholder="Select Year"
                            onChange={(e) => this.setState({ valueYear: e })}
                            optionLabelProp="label"
                            value={this.state.valueYear}
                          >
                            {this.state.masterYear.map((item, index) => (
                              <Option value={item.value} label={item.text}>
                                <div className="demo-option-label-item">
                                  <span role="img" aria-label={item.text}>
                                    {item.text}
                                  </span>
                                </div>
                              </Option>
                            ))}
                          </Select>
                        </div>
                        <div className="col-sm-auto col-md-3">
                          <Select
                            mode="multiple"
                            style={{
                              width: "100%",
                            }}
                            placeholder="Select Month"
                            onChange={(e) => this.setState({ valueMonth: e })}
                            optionLabelProp="label"
                            value={this.state.valueMonth}
                          >
                            {this.state.masterMonth.map((item, index) => (
                              <Option value={item.value} label={item.text}>
                                <div className="demo-option-label-item">
                                  <span role="img" aria-label={item.text}>
                                    {item.text}
                                  </span>
                                </div>
                              </Option>
                            ))}
                          </Select>
                        </div>
                        <div
                          className="col-sm-auto col-md-1"
                          style={{ textAlign: "center" }}
                        >
                          <Button
                            type="primary"
                            shape="circle"
                            icon={<SearchOutlined />}
                            onClick={() => this.onFilterData()}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-sm-auto col-md-8">
                        <div className="row mb-3">
                          <div
                            className="ant-col ant-col-xs-24 ant-col-xl-6"
                            style={{ padding: "5px 5px 5px 5px" }}
                          >
                            <div
                              className="card-dashboard"
                              style={{ padding: "10px" }}
                            >
                              <h3 className="font-mont-sb fs-14 c-blue">
                                Claim
                              </h3>
                              <div
                                style={{
                                  margin: "-20px -30px 0 -30px",
                                  overflow: "hidden",
                                  marginTop: "30px",
                                }}
                              >
                                <ChartStatic
                                  data={
                                    this.state.data_dashbord?.circle_claim
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="ant-col ant-col-xs-24 ant-col-xl-6"
                            style={{ padding: "5px 5px 5px 5px" }}
                          >
                            <div
                              className="card-dashboard"
                              style={{ padding: "10px" }}
                            >
                              <h3 className="font-mont-sb fs-14 c-blue">
                                Production
                              </h3>
                              <div
                                style={{
                                  margin: "-20px -30px 0 -30px",
                                  overflow: "hidden",
                                  marginTop: "30px",
                                }}
                              >
                                <ChartStatic
                                  data={
                                    this.state.data_dashbord?.circle_claim
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="ant-col ant-col-xs-24 ant-col-xl-6"
                            style={{ padding: "5px 5px 5px 5px" }}
                          >
                            <div
                              className="card-dashboard"
                              style={{ padding: "10px" }}
                            >
                              <h3 className="font-mont-sb fs-14 c-blue">
                                Preventive Maintenance
                              </h3>
                              <div
                                style={{
                                  margin: "-20px -30px 0 -30px",
                                  overflow: "hidden",
                                  marginTop: "30px",
                                }}
                              >
                                <ChartStatic
                                  data={
                                    this.state.data_dashbord?.circle_preventive_ma
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="ant-col ant-col-xs-24 ant-col-xl-6"
                            style={{ padding: "5px 5px 5px 5px" }}
                          >
                            <div
                              className="card-dashboard"
                              style={{ padding: "10px" }}
                            >
                              <h3 className="font-mont-sb fs-14 c-blue">
                                Post
                              </h3>
                              <div
                                style={{
                                  margin: "-20px -30px 0 -30px",
                                  overflow: "hidden",
                                  marginTop: "30px",
                                }}
                              >
                                <ChartStatic
                                  data={this.state.data_dashbord?.circle_post}

                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div
                            className="ant-col ant-col-xs-24 ant-col-xl-24"
                            style={{ padding: "5px 5px 5px 5px" }}
                          >
                            <div className="card-dashboard ">
                              <h3 className="font-mont-sb fs-16 c-blue">
                                Job Summary Customer Service
                              </h3>
                              <div>
                                <ChartJobRemain
                                  data={
                                    this.state.data_dashbord?.line_summary_customer_service

                                  }
                                  type={"sumCustomer"}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-12">
                            <div className="row mb-4">
                              <div
                                className="ant-col ant-col-xs-24 ant-col-xl-6"
                                style={{ padding: "5px 5px 5px 5px" }}
                              >
                                <div
                                  className="card-dashboard"
                                  style={{ padding: "10px" }}
                                >
                                  <h3 className="font-mont-sb fs-14 c-blue">
                                    Photo
                                  </h3>
                                  <div
                                    style={{
                                      margin: "-20px -30px 0 -30px",
                                      overflow: "hidden",
                                      marginTop: "30px",
                                    }}
                                  >
                                    <ChartStatic
                                      data={
                                        this.state.data_dashbord?.circle_photo
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                              <div
                                className="ant-col ant-col-xs-24 ant-col-xl-6"
                                style={{ padding: "5px 5px 5px 5px" }}
                              >
                                <div
                                  className="card-dashboard"
                                  style={{ padding: "10px" }}
                                >
                                  <h3 className="font-mont-sb fs-14 c-blue">
                                    Report
                                  </h3>
                                  <div
                                    style={{
                                      margin: "-20px -30px 0 -30px",
                                      overflow: "hidden",
                                      marginTop: "30px",
                                    }}
                                  >
                                    <ChartStatic
                                      data={
                                        this.state.data_dashbord?.circle_report

                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                              <div
                                className="ant-col ant-col-xs-24 ant-col-xl-6"
                                style={{ padding: "5px 5px 5px 5px" }}
                              >
                                <div
                                  className="card-dashboard"
                                  style={{ padding: "10px" }}
                                >
                                  <h3 className="font-mont-sb fs-14 c-blue">
                                    Graphic Layout
                                  </h3>
                                  <div
                                    style={{
                                      margin: "-20px -30px 0 -30px",
                                      overflow: "hidden",
                                      marginTop: "30px",
                                    }}
                                  >
                                    <ChartStatic
                                      data={
                                        this.state.data_dashbord?.circle_graphic_layout
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                              <div
                                className="ant-col ant-col-xs-24 ant-col-xl-6"
                                style={{ padding: "5px 5px 5px 5px" }}
                              >
                                <div
                                  className="card-dashboard"
                                  style={{ padding: "10px" }}
                                >
                                  <h3 className="font-mont-sb fs-14 c-blue">
                                    Run zone
                                  </h3>
                                  <div
                                    style={{
                                      margin: "-20px -30px 0 -30px",
                                      overflow: "hidden",
                                      marginTop: "30px",
                                    }}
                                  >
                                    <ChartStatic
                                      data={
                                        this.state.data_dashbord?.circle_claim_runzone
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div
                            className="ant-col ant-col-xs-24 ant-col-xl-24"
                            style={{ padding: "5px 5px 5px 5px" }}
                          >
                            <div className="card-dashboard">
                              <h3 className="font-mont-sb fs-16 c-blue">
                                Job Summary Maintenance Service
                              </h3>
                              <div>
                                <ChartJobRemain
                                  data={
                                    this.state.data_dashbord?.line_summary_ma_service
                                  }
                                  type={"sumMaintenance"}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        className="col-sm-auto col-md-4 w-100"
                        style={{ marginTop: "5px" }}
                      >
                        <div className="wrapper-dashboard-right">
                          <div className="head">
                            <div
                              className="row mb-2"
                              style={{ padding: "0 20px" }}
                            >
                              <div className="col-6">
                                <span className="font-mont-m fs-14 c-white">
                                  Team Management
                                </span>
                              </div>
                              <div
                                className="col-6"
                                style={{ textAlign: "right" }}
                              >
                                <span className="font-mont-m fs-14 c-white">
                                  {
                                    this.state.data_dashbord.team_management[0].working
                                  }{" "}
                                  online
                                </span>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col text-center">
                                <h4 className="font-mont-sb fs-26 c-white m-0">
                                  {
                                    this.state.data_dashbord.team_management[0].employee
                                  }
                                </h4>
                                <span className="font-mont-m fs-14 c-white">
                                  Employee
                                </span>
                              </div>
                              <div
                                className="col text-center"
                                style={{
                                  borderLeft:
                                    "1px solid rgba(255, 255, 255, 0.25)",
                                }}
                              >
                                <h4 className="font-mont-sb fs-26 c-white m-0">
                                  {
                                    this.state.data_dashbord.team_management[0].team_qty
                                  }
                                </h4>
                                <span className="font-mont-m fs-14 c-white">
                                  Team
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row mt-3">
                          <div
                            className="ant-col ant-col-xs-24 ant-col-xl-24"
                            style={{
                              textAlign: "left",
                              paddingLeft: "15px",
                              paddingRight: "15px",
                            }}
                          >
                            <div className="card-dashboard">
                              <h3
                                className="font-mont-sb fs-16 c-blue"
                                style={{ borderBottom: "1px solid" }}
                              >
                                On time SLA rate : Employee
                              </h3>

                              <div className="row mt-2">
                                <div className="col-9">
                                  <div className="row">
                                    <div className="col-6">
                                      <span className="font-mont-m fs-10 ">
                                        TEAM
                                      </span>
                                    </div>
                                    <div className="col-4">
                                      <span className="font-mont-m fs-10 ">
                                        JOB
                                      </span>
                                    </div>
                                    <div
                                      className="col-2"
                                      style={{ textAlign: "center" }}
                                    >
                                      <span className="font-mont-m fs-10 ">
                                        COMPLETE
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {this.state.data_dashbord?.sla_employee.map(
                                (item, index) => (
                                  <div className="row mt-1 ml-1">
                                    <div className="col-9">
                                      <div className="row">
                                        <div className="col-6">
                                          <span className="font-mont-m fs-10 ">
                                            {item.team_group_name}
                                          </span>
                                        </div>
                                        <div className="col-4">
                                          <span className="font-mont-m fs-10 ">
                                            {item.count_finish_job}
                                          </span>
                                        </div>
                                        <div
                                          className="col-2"
                                          style={{ textAlign: "center" }}
                                        >
                                          <span className="font-mont-m fs-10 ">
                                            {item.percent_sla}
                                            {"%"}
                                          </span>
                                        </div>
                                        <div
                                          className="col-11"
                                          style={{
                                            height: "4px",
                                            background:
                                              "linear-gradient(90deg,  #464749 " +
                                              item.percent_sla +
                                              "%, rgb(219 221 225) " +
                                              (100 - item.percent_sla) +
                                              "%)",
                                            color: "#FFFFFF",
                                            borderRadius: "5px",
                                          }}
                                        ></div>
                                      </div>
                                    </div>
                                    <div className="col-3">
                                      {/* <span className="font-mont-m fs-10 c-blue fs-12"> */}

                                      <Tooltip
                                        placement="topLeft"
                                        title={item.team_group_name}
                                      >
                                        <Button
                                          style={{
                                            width: "100%",
                                            height: "25px",
                                            fontSize: "11px",
                                            padding: "1px",
                                            backgroundColor: "#464749",
                                            color: "#FFFFFF",
                                          }}
                                        >
                                          สาเหตุ
                                        </Button>
                                      </Tooltip>
                                      {/* </span> */}
                                    </div>
                                  </div>
                                )
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="row mt-3">
                          <div
                            className="ant-col ant-col-xs-24 ant-col-xl-24"
                            style={{
                              paddingLeft: "15px",
                              paddingRight: "15px",
                            }}
                          >
                            <div className="card-dashboard">
                              <div className="row mt-2 mb-2">
                                <div
                                  className="col-12"
                                  style={{ textAlign: "left" }}
                                >
                                  <span className="font-mont-m fs-14 c-blue ">
                                    <b>Claim</b>
                                  </span>
                                  <span className="font-mont-m fs-12 c-blue ml-2">
                                    <b> Total </b>{" "}
                                    <span
                                      style={{
                                        color: "#464749",
                                        marginLeft: "5px",
                                      }}
                                    >
                                      {" "}
                                      200 jobs :{" "}
                                    </span>
                                  </span>
                                  <span className="font-mont-m fs-12 c-blue ml-2">
                                    <b className="ml-1"> On SLA </b>{" "}
                                    <span
                                      style={{
                                        color: "#464749",
                                        marginLeft: "5px",
                                      }}
                                    >
                                      {" "}
                                      150 jobs (70%) :{" "}
                                    </span>
                                    <b className="ml-1"> On SLA </b>{" "}
                                    <span
                                      style={{
                                        color: "#464749",
                                        marginLeft: "5px",
                                      }}
                                    >
                                      {" "}
                                      50 jobs (30%){" "}
                                    </span>
                                  </span>
                                </div>
                              </div>
                              {this.state.data_dashbord?.sla_claim.map(
                                (item, index) => (
                                  <div className="row mt-1">
                                    <div className="col-2">
                                      <span
                                        className="font-mont-m "
                                        style={{
                                          color: "#464749",
                                          fontSize: "10px",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {/* {item.name} */}
                                        <br />
                                        <span className="font-mont-m fs-10 ">
                                          {item.count_job_id}
                                          {" job"}
                                        </span>
                                      </span>
                                    </div>
                                    <div className="col-8">
                                      <span className="font-mont-m fs-10 ">
                                        {item.asset_type_name === null
                                          ? "-"
                                          : item.asset_type_name}
                                      </span>
                                      <div
                                        style={{
                                          background:
                                            "linear-gradient(90deg,  #37AB74 " +
                                            item.percent_sla +
                                            "%, #DDF1E7 " +
                                            (100 - item.percent_sla) +
                                            "%)",
                                          borderRadius: "5px",
                                          height: "20px",
                                        }}
                                      ></div>
                                    </div>
                                    <div
                                      className="col-2"
                                      style={{
                                        textAlign: "center",
                                        color: "#464749",
                                      }}
                                    >
                                      <br />
                                      <span className="font-mont-m fs-10 ">
                                        {item.count_finish_job}
                                        {" job"}
                                      </span>
                                    </div>
                                  </div>
                                )
                              )}
                              <div className="row mt-2">
                                <div
                                  className="col-12"
                                  style={{ textAlign: "left" }}
                                >
                                  <span className="font-mont-m fs-14 c-blue ">
                                    <b>Post</b>
                                  </span>
                                  <span className="font-mont-m fs-12 c-blue ml-2">
                                    <b> Total </b>{" "}
                                    <span
                                      style={{
                                        color: "#464749",
                                        marginLeft: "5px",
                                      }}
                                    >
                                      {" "}
                                      200 jobs :{" "}
                                    </span>
                                  </span>
                                  <span className="font-mont-m fs-12 c-blue ml-2">
                                    <b className="ml-1"> On SLA </b>{" "}
                                    <span
                                      style={{
                                        color: "#464749",
                                        marginLeft: "5px",
                                      }}
                                    >
                                      {" "}
                                      150 jobs (70%) :{" "}
                                    </span>
                                    <b className="ml-1"> On SLA </b>{" "}
                                    <span
                                      style={{
                                        color: "#464749",
                                        marginLeft: "5px",
                                      }}
                                    >
                                      {" "}
                                      50 jobs (30%){" "}
                                    </span>
                                  </span>
                                </div>
                              </div>
                              {this.state.data_dashbord?.sla_post.map(
                                (item, index) => (
                                  <div className="row mt-1">
                                    <div className="col-2">
                                      <span
                                        className="font-mont-m "
                                        style={{
                                          color: "#464749",
                                          fontSize: "10px",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {/* {item.name} */}
                                        <br />
                                        <span className="font-mont-m fs-10 ">
                                          {item.count_job_id}
                                          {" job"}
                                        </span>
                                      </span>
                                    </div>
                                    <div className="col-8">
                                      <span className="font-mont-m fs-10 ">
                                        {item.asset_type_name === null
                                          ? "-"
                                          : item.asset_type_name}
                                      </span>
                                      <div
                                        style={{
                                          background:
                                            "linear-gradient(90deg,  #37AB74 " +
                                            item.percent_sla +
                                            "%, #DDF1E7 " +
                                            (100 - item.percent_sla) +
                                            "%)",
                                          borderRadius: "5px",
                                          height: "20px",
                                        }}
                                      ></div>
                                    </div>
                                    <div
                                      className="col-2"
                                      style={{
                                        textAlign: "center",
                                        color: "#464749",
                                      }}
                                    >
                                      <br />
                                      <span className="font-mont-m fs-10 ">
                                        {item.count_finish_job}
                                        {" job"}
                                      </span>
                                    </div>
                                  </div>
                                )
                              )}
                              <div className="row mt-2">
                                <div
                                  className="col-12"
                                  style={{ textAlign: "left" }}
                                >
                                  <span className="font-mont-m fs-14 c-blue ">
                                    <b>Photo</b>
                                  </span>
                                  <span className="font-mont-m fs-12 c-blue ml-2">
                                    <b> Total </b>{" "}
                                    <span
                                      style={{
                                        color: "#464749",
                                        marginLeft: "5px",
                                      }}
                                    >
                                      {" "}
                                      200 jobs :{" "}
                                    </span>
                                  </span>
                                  <span className="font-mont-m fs-12 c-blue ml-2">
                                    <b className="ml-1"> On SLA </b>{" "}
                                    <span
                                      style={{
                                        color: "#464749",
                                        marginLeft: "5px",
                                      }}
                                    >
                                      {" "}
                                      150 jobs (70%) :{" "}
                                    </span>
                                    <b className="ml-1"> On SLA </b>{" "}
                                    <span
                                      style={{
                                        color: "#464749",
                                        marginLeft: "5px",
                                      }}
                                    >
                                      {" "}
                                      50 jobs (30%){" "}
                                    </span>
                                  </span>
                                </div>
                              </div>
                              {this.state.data_dashbord?.sla_photo.map(
                                (item, index) => (
                                  <div className="row mt-1">
                                    <div className="col-2">
                                      <span
                                        className="font-mont-m "
                                        style={{
                                          color: "#464749",
                                          fontSize: "10px",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {/* {item.name} */}
                                        <br />
                                        <span className="font-mont-m fs-10 ">
                                          {item.count_job_id}
                                          {" job"}
                                        </span>
                                      </span>
                                    </div>
                                    <div className="col-8">
                                      <span className="font-mont-m fs-10 ">
                                        {item.asset_type_name === null
                                          ? "-"
                                          : item.asset_type_name}
                                      </span>
                                      <div
                                        style={{
                                          background:
                                            "linear-gradient(90deg,  #37AB74 " +
                                            item.percent_sla +
                                            "%, #DDF1E7 " +
                                            (100 - item.percent_sla) +
                                            "%)",
                                          borderRadius: "5px",
                                          height: "20px",
                                        }}
                                      ></div>
                                    </div>
                                    <div
                                      className="col-2"
                                      style={{
                                        textAlign: "center",
                                        color: "#464749",
                                      }}
                                    >
                                      <br />
                                      <span className="font-mont-m fs-10 ">
                                        {item.count_finish_job}
                                        {" job"}
                                      </span>
                                    </div>
                                  </div>
                                )
                              )}
                              <div className="row mt-2">
                                <div
                                  className="col-12"
                                  style={{ textAlign: "left" }}
                                >
                                  <span className="font-mont-m fs-14 c-blue ">
                                    <b>Report</b>
                                  </span>
                                  <span className="font-mont-m fs-12 c-blue ml-2">
                                    <b> Total </b>{" "}
                                    <span
                                      style={{
                                        color: "#464749",
                                        marginLeft: "5px",
                                      }}
                                    >
                                      {" "}
                                      200 jobs :{" "}
                                    </span>
                                  </span>
                                  <span className="font-mont-m fs-12 c-blue ml-2">
                                    <b className="ml-1"> On SLA </b>{" "}
                                    <span
                                      style={{
                                        color: "#464749",
                                        marginLeft: "5px",
                                      }}
                                    >
                                      {" "}
                                      150 jobs (70%) :{" "}
                                    </span>
                                    <b className="ml-1"> On SLA </b>{" "}
                                    <span
                                      style={{
                                        color: "#464749",
                                        marginLeft: "5px",
                                      }}
                                    >
                                      {" "}
                                      50 jobs (30%){" "}
                                    </span>
                                  </span>
                                </div>
                              </div>
                              {this.state.data_dashbord?.sla_report.map(
                                (item, index) => (
                                  <div className="row mt-1">
                                    <div className="col-2">
                                      <span
                                        className="font-mont-m "
                                        style={{
                                          color: "#464749",
                                          fontSize: "10px",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {/* {item.name} */}
                                        <br />
                                        <span className="font-mont-m fs-10 ">
                                          {item.count_job_id}
                                          {" job"}
                                        </span>
                                      </span>
                                    </div>
                                    <div className="col-8">
                                      <span className="font-mont-m fs-10 ">
                                        {item.asset_type_name === null
                                          ? "-"
                                          : item.asset_type_name}
                                      </span>
                                      <div
                                        style={{
                                          background:
                                            "linear-gradient(90deg,  #37AB74 " +
                                            item.percent_sla +
                                            "%, #DDF1E7 " +
                                            (100 - item.percent_sla) +
                                            "%)",
                                          borderRadius: "5px",
                                          height: "20px",
                                        }}
                                      ></div>
                                    </div>
                                    <div
                                      className="col-2"
                                      style={{
                                        textAlign: "center",
                                        color: "#464749",
                                      }}
                                    >
                                      <br />
                                      <span className="font-mont-m fs-10 ">
                                        {item.count_finish_job}
                                        {" job"}
                                      </span>
                                    </div>
                                  </div>
                                )
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-12">
                            <div className="card-dashboard">
                              <h3
                                className="font-mont-sb fs-16 c-blue"
                                style={{ borderBottom: "1px solid" }}
                              >
                                Top 10 Asset Maintenance
                              </h3>
                              <div className="row">
                                <div className="col-auto table-responsive p-0">
                                  <table
                                    className="table table-borderless"
                                    style={{ lineHeight: "1" }}
                                  >
                                    <thead>
                                      <tr style={{ color: "#0510A3" }}>
                                        {/* <th scope="col">No.</th> */}
                                        <th scope="col">Code</th>
                                        <th scope="col">Name</th>
                                        <th scope="col">Group</th>
                                        <th
                                          scope="col"
                                          style={{ whiteSpace: "nowrap" }}
                                        >
                                          Total Jobs
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.data_top_asset.map(
                                        (item, index) => (
                                          <tr>
                                            {/* <th scope="row">{item.no}</th> */}
                                            <td className="tdoverflowCode">
                                              <Tooltip title={item.asset_code}>
                                                <span> {item.asset_code}</span>
                                              </Tooltip>
                                            </td>
                                            <td
                                              style={{ color: "#0510A3" }}
                                              className="tdoverflow"
                                            >
                                              <Tooltip title={item.asset_name}>
                                                <span> {item.asset_name}</span>
                                              </Tooltip>
                                            </td>
                                            <td className="tdoverflow">
                                              <Tooltip
                                                title={item.asset_type_name}
                                              >
                                                <span>
                                                  {" "}
                                                  {item.asset_type_name}
                                                </span>
                                              </Tooltip>
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                              <Tooltip title={item.total_jobs}>
                                                <span> {item.total_jobs}</span>
                                              </Tooltip>
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
       
          </>
        ) : null}
        </Spin>
      </>
    );
  }
}

export default Dashboard;
